// @flow
import React, { PureComponent } from 'react';
import { Redirect } from 'react-router-dom';

import CompetitionDocuments from 'containers/competition/CompetitionDocumentsContainer';
import CompetitionMedia from 'containers/competition/CompetitionMediaContainer';
import CompetitionResult from 'components/competition/CompetitionResult';
import Breadcrumb from 'components/fragments/Breadcrumb';
import Loading from 'components/fragments/Loading';
import SubMenu from 'components/header/SubMenu';
import { STATUS_DEFAULT, STATUS_FAILURE, STATUS_LOADING, STATUS_UNKNOWN } from 'constants/statusConstants';
import { withHelmet } from 'infrastructure/seo/Helmet';
import type { CompetitionType } from 'types/Competition';
import type { Status } from 'types/Status';

const pages = [CompetitionResult, CompetitionDocuments, CompetitionMedia];

export type StateProps = {
  competition: CompetitionType,
  ligue_id: number,
  status: Status
};

export type DispatchProps = {
  fetchCompetition: (slug: string, ligue_id: number) => void
};

type Props = {
  match: {
    params: {
      slug: string
    }
  }
} & StateProps &
  DispatchProps;

type State = {
  currentPageId: number
};

class CompetitionDetail extends PureComponent<Props, State> {
  props: Props;
  state: State = {
    currentPageId: 0
  };

  componentDidMount() {
    const {
      ligue_id,
      match: {
        params: { slug }
      }
    } = this.props;

    // on ne fetche que si on a la ligue pour ne pas faire une requête pour rien
    if (ligue_id && ligue_id > 0) {
      this.props.fetchCompetition(slug, ligue_id);
    }
  }

  componentDidUpdate(prevProps, prevState) {
    const {
      ligue_id,
      match: {
        params: { slug }
      }
    } = this.props;

    if (prevProps.ligue_id !== ligue_id && ligue_id > 0) {
      this.props.fetchCompetition(slug, ligue_id);
      
    }
  }

  setCurrentPageId = (currentPageId: number) => {
    this.setState({ currentPageId });
  };

  renderPage = () => {
    const Component = pages[this.state.currentPageId] || CompetitionResult;
    return <Component competition={this.props.competition} />;
  };

  render() {
    const { status } = this.props;
    const { division, documents, medias } = this.props.competition;

    if (status === STATUS_LOADING || status === STATUS_DEFAULT) {
      return <Loading />;
    } else if (status === STATUS_FAILURE || status === STATUS_UNKNOWN) {
      console.log(status, 'redirige vers 404');
      return <Redirect to="/404" />;
    }

    const subMenu = ['Résultats'];
    if (documents.documents && documents.documents.length > 0) {
      subMenu.push('Documents utiles');
    }
    if (medias.media && medias.media.length > 0) {
      subMenu.push('Contenu média');
    }

    return (
      <>
        <section className="banner">
          <div className="banner__thumbnail img-green" />
          <div className="container">
            <Breadcrumb
              elements={[{ name: 'accueil', to: '/' }, { name: 'compétitions', to: '/competitions' }, division]}
              isDark
            />
            <h1 className="ft-h2">{division}</h1>
            <p className="banner__desc">{`L'ensemble des résultats et contenus du championnat ${division}.`}</p>
          </div>
        </section>
        <SubMenu onPageChanged={this.setCurrentPageId} subMenus={subMenu} />
        {this.renderPage()}
      </>
    );
  }
}

export default withHelmet(CompetitionDetail)((Helmet, pageProps) => (
  <Helmet>
    <title>{pageProps.competition.meta_title}</title>
    <meta name={'description'} content={pageProps.competition.meta_description} />
    <link rel={'canonical'} href={window.location.href} />
  </Helmet>
));
